module.exports = __webpack_public_path__ + "static/img/v_8.0ca2aae6.png";